
<template>
<!--   <vx-tooltip delay="15s" :title="`${task.title}`" :htmlEnabled="true" text="<ul>
    <li><b>⇧Shift+d</b> Delete task</li>
    <li><b>⇧Shift+t</b> Assign for today</li>
  </ul>"> -->
    <TaskCard
      class="task shadow hover:shadow-lg text-dark select-none border-solid border-2 border-transparent hover:border-black hover:shadow-inner"
      :class="{'text-white': paintItWhite}"
      :title="task.title"
      :title-color="task.titleColor"
      :collapsed="collapsed"
      :showProgress="subtasksPresent"
      :progressPercent="subtasksProgress"
      :done="task.done"
      :cardBackground="task.backgroundColor"
      :deadline="deadline"
      :doneOn="task.doneOn"
      :subtaskIndicator="subtaskIndicator"
      :taskBoxName="taskBoxName"
      :task="task"
      @toggleCollapse="collapseCallback"
      @toggleDone="toggleDone"
      @mouseover="hover = true"
      @mouseleave="hover = false"
      @keyup="keymonitor"
      @doubleClick="$emit('doubleClick')"
      @edit="$emit('edit')"
      @destroy="destroy"
      @someday="setSomeday"
      @today="setToday"
      @nextMonday="setNextMonday"
      @soon="setSoon"
      @setDeadline="setDeadline"
      @tomorrow="setTomorrow"
      @dayAfterTomorrow="setDayAfterTomorrow"
      @click.stop="$emit('edit')"
      @openTask="taskOpened = !taskOpened"
      @colorChanged="changeBackgroundColor"
      collapsable
    >
        <div @click.stop="">
          <draggable
            v-if="subtasksPresent"
            v-model="subtasksArray"
            handle=".subtask-handle"
            ghost-class="ghost-task"
            :sort="true"
            group="`subtasks_${task.id}`"
            drag-class="task-drag"
            :disabled="isMobile"
          >
            <template v-for="subtask in subtasksArray">
              <Subtask
                :key="subtask.id"
                :subtask="subtask"
                :task="task"
                @subtaskEdit="subtaskEditCallback"
                @subtaskDelete="subtaskDeleteCallback"
                class="mb-1 subtask-handle"
              />
            </template>
          </draggable>

          <div class="flex items-center">
            <feather-icon v-if="addSubTaskSkeleton" :class="actionElementCss" icon="PlusCircleIcon" class="w-5 mr-2 cursor-pointer bold" @click="saveSkeleton" />
            <feather-icon v-else :class="actionElementCss" icon="PlusIcon" class="w-5 mr-2 cursor-pointer" @click="activateSkeletonInput"/>
            <vs-input class="inputx skeleton-input" :class="{'white-placeholder': paintItWhite}" ref="skeleton_input" @keyup.enter.native="saveSkeleton" @focusout="saveSkeleton" :placeholder="!subtasksPresent && 'add subtask'" v-model="addSubTaskSkeleton" />
          </div>
        </div>
    </TaskCard>
  <!-- </vx-tooltip> -->
</template>

<script>
import TaskCard from './TaskCard'
import Subtask from './Subtask'
import draggable from 'vuedraggable'
import keepOrderBy from '@/helpers/keepOrderBy'
import id from '@/helpers/id'
import _ from 'lodash'
import trackAnalytics from '@/helpers/trackAnalytics'
import { areEqual, getNextMonday} from '@/helpers/date'
import { mapGetters } from 'vuex'

export default {
  components: {
    TaskCard,
    Subtask,
    draggable
  },
  props: {
    task: {
      type: Object,
      required: true,
    },
    forceOpen: {
      type: Boolean,
    },
    taskBoxName: {
      type: String,
      required: false
    }
  },

  // computed: {
  //   titleColor: "primary"
  // }
  data () {
    return {
      addSubTaskSkeleton: null,
      subtasksArray: [],
      hover: false,
      taskOpened: false,
    }
  },
  watch: {
    // 'hover': {
    //   immediate: false,
    //   handler (hover) {
    //     if (hover) {
    //       console.log('Hovering over',  this.task.title)
    //     }
    //   }
    // },
    'subtasks': {
      immediate: true,
      handler () {
        this.subtasksArray = keepOrderBy(this.subtasksArray, this.subtasks, true)
        // console.log('WATCHER loadedSubgoals.size')
        // this.loadSubgoals()
      }
    },
    'collapsed': {
      immediate: false,
      handler () {
        this.collapseCallback()
      }
    }
  },
  computed: {
    ...mapGetters([
      'today',
      'tomorrow',
      'dayAfterTomorrow'
    ]),
    paintItWhite () {
      return this.task.backgroundColor
    },
    subtaskIndicator () {
      if (this.subtasks.length > 0) {
        return `(${this.subtasksDoneCount}/${this.subtasks.length})`
      }
    },
    subtasks () {
      return this.task.subtasks || []
    },
    isMobile () {
      return this.$store.getters.isMobile
    },
    collapsed () {
      // if (this.forceOpen === true) return !this.subtasksPresent
      // if (this.forceOpen === false) return true

      // return !this.taskOpened || this.task.done || !this.subtasksPresent
      return !this.taskOpened
    },
    subtasksPresent () {
      return this.subtasks && this.subtasks.length > 0
    },
    subtasksDoneCount () {
      return _.filter(this.subtasks, 'done').length
    },
    subtasksProgress () {
      return _.max([Math.round(100 * this.subtasksDoneCount / this.subtasks.length), 1])
    },
    deadline () {
      if (this.task.deadline) {
        if (areEqual(this.task.deadline.toDate(), this.today) || areEqual(this.task.deadline.toDate(), this.tomorrow)) {
          return null
        }
      }

      return this.task.deadline
    },
  },
  created () {
    window.addEventListener('keypress', this.keymonitor)
  },
  destroyed () {
    window.removeEventListener('keypress', this.keymonitor)
  },
  methods: {
    /* eslint-disable */
    keymonitor (events) {
      if (!this.hover) return
      // who caused it? "event.target.id"
      // console.log('keyup from id: '+event.target.id)
      // what was pressed?

      // console.log(event)

      // if (event.ctrlKey || event.altKey) {
        // const key = event.key || String.fromCharCode(event.keyCode)
        // if (key === 'd' || key === 'D') {
        //   this.destroy()
        // } else if (key === 't' || key === 'T') {
        //   this.$store.dispatch('UPDATE_TASK', { task: this.task, updateFields: { deadline: midnight(), showList: null } })
        // } else if (key == 'A' || key == 'a') {
        //   this.$store.dispatch('UPDATE_TASK', { task: this.task, updateFields: { deadline: null, showList: 'soon' } })

        // let color = ''

      //   if (event.code === 'Digit1') {
      //     color = '#FFB70A'
      //   } else if (event.code === 'Digit2') {
      //     color = '#3DC9B3'
      //   } else if (event.code === 'Digit3') {
      //     color = '#FF006E'
      //   } else if (event.code === 'Digit4') {
      //     color = '#4CC9F0'
      //   } else if (event.code === 'Digit5') {
      //     color = '#00D09D'
      //   }

      //   color = (color === this.task.backgroundColor ? '' : color)
      //   this.$store.dispatch('UPDATE_TASK', { task: this.task, updateFields: { backgroundColor: color } })
      // }
    },
    setSomeday () {
      trackAnalytics(this, 'app_action', 'task', 'task_set_someday', this.$store.getters.daysFromRegistration)
      this.$store.dispatch('UPDATE_TASK', { task: this.task, updateFields: { deadline: null, showList: 'someday', listIndex: null } })
    },
    setToday () {
      trackAnalytics(this, 'app_action', 'task', 'task_set_today', this.$store.getters.daysFromRegistration)
      this.$store.dispatch('UPDATE_TASK', { task: this.task, updateFields: { deadline: this.today, showList: null, listIndex: null } })
    },
    setNextMonday () {
      this.$store.dispatch('UPDATE_TASK', { task: this.task, updateFields: { deadline: getNextMonday(this.today), showList: null, listIndex: null } })
    },
    setTomorrow () {
      trackAnalytics(this, 'app_action', 'task', 'task_set_tomorrow', this.$store.getters.daysFromRegistration)
      this.$store.dispatch('UPDATE_TASK', { task: this.task, updateFields: { deadline: this.tomorrow, showList: null, listIndex: null } })
    },
    setDayAfterTomorrow () {
      trackAnalytics(this, 'app_action', 'task', 'task_set_day_after_tomorrow', this.$store.getters.daysFromRegistration)
      this.$store.dispatch('UPDATE_TASK', { task: this.task, updateFields: { deadline: this.dayAfterTomorrow, showList: null, listIndex: null } })
    },
    setDeadline (deadline) {
      trackAnalytics(this, 'app_action', 'task', 'set_deadline', this.$store.getters.daysFromRegistration)
      this.$store.dispatch('UPDATE_TASK', { task: this.task, updateFields: { deadline, showList: null, listIndex: null } })
    },
    setSoon () {
      trackAnalytics(this, 'app_action', 'task', 'task_set_soon', this.$store.getters.daysFromRegistration)
      this.$store.dispatch('UPDATE_TASK', { task: this.task, updateFields: { deadline: null, showList: 'soon', listIndex: null } })
    },
    changeBackgroundColor (color) {
      console.log('changeBackgroundColor', color)
      trackAnalytics(this, 'app_action', 'task', 'task_set_color', this.$store.getters.daysFromRegistration)
      this.$store.dispatch('UPDATE_TASK', { task: this.task, updateFields: { backgroundColor: color } })
    },
    destroy () {
      trackAnalytics(this, 'app_action', 'task', 'task_delete', this.$store.getters.daysFromRegistration)
      this.$store.dispatch('DELETE_TASK', { task: this.task })
    },
    toggleDone (done) {

      if (done) {
        this.$store.dispatch('PLAY_SOUND_EFFECT', 'tada')

        if (this.taskBoxName == 'today') {
          if (_.reject(this.$store.getters.todayTasks, 'done').length == 1) {
            this.notifier.allTodayTasksCompleted()
            } else if (_.filter(this.$store.getters.todayTasks, 'done').length == 0) {
             this.notifier.firstTodayTasksCompleted()
            }
          }
        }

      if (done) {
        trackAnalytics(this, 'app_action', 'task', 'task_done', this.$store.getters.daysFromRegistration)
        this.$store.dispatch('UPDATE_TASK', { task: this.task, updateFields: { done, doneOn: this.today } })
      } else {
        this.$store.dispatch('UPDATE_TASK', { task: this.task, updateFields: { done, doneOn: null } })
      }

    },
    collapseCallback () {
      // console.log('collapseCallback', collapsed)
      // this.taskOpened = !collapsed
      // remote

      if (this.collapsed === false && !this.subtasksPresent) {
        this.activateSkeletonInput()
      }
    },
    activateSkeletonInput () {
      this.$forceNextTick(() => this.$refs['skeleton_input'].focusInput())
    },
    subtaskEditCallback (subtask) {
      console.info(subtask)
      const newSubtasks = [...this.task.subtasks]

      const foundIndex = newSubtasks.findIndex(x => x.id === subtask.id)
      newSubtasks[foundIndex] = subtask
      this.updateSubtasks(newSubtasks)
    },
    subtaskDeleteCallback (subtask) {
      this.updateSubtasks(_.reject(this.task.subtasks, (s) => s.id === subtask.id))
    },
    updateSubtasks (subtasks) {
      trackAnalytics(this, 'app_action', 'task', 'task_update_subtasks', this.$store.getters.daysFromRegistration)
      this.$store.dispatch('UPDATE_TASK', { task: this.task, updateFields: { subtasks } })
    },
    saveSkeleton () {
      console.log('save skeleton', this.addSubTaskSkeleton)

      if (this.addSubTaskSkeleton) {
        this.updateSubtasks(_.concat(this.task.subtasks, { title: this.addSubTaskSkeleton, done: false, id: id() }))

        this.addSubTaskSkeleton = null
        this.$forceNextTick(() => this.$refs['skeleton_input'].focusInput())

      }


    }
  }
}

</script>
<style lang="scss">
.task {
  .vx-card__header {
    padding: 0.6rem
  }
}

.white-placeholder {
  .input-span-placeholder {
    color: white;
  }
}
</style>
